import React from "react";
import { PageHeader } from '../components/PageHeader'

export function Projects() {
  return (
    <div className="page">
      <PageHeader title={'Projects'}/>
      <div className="page-content">
        {/* <div className="project-item">
          <span>React Chess</span>
          <p>Local multiplayer chess app using React.</p>
          <a target="_blank" rel="noreferrer" href="https://gb-react-chess.netlify.app/">https://gb-react-chess.netlify.app/</a>
        </div> */}
        <div className="project-item">
          <span>Labyrinth</span>
          <p>Original web game using React and NodeJS.</p>
          <a target="_blank" rel="noreferrer" href="https://gb-labyrinth-react.netlify.app">https://gb-labyrinth-react.netlify.app</a> 
        </div>
        <div className="project-item">
          <span>Acronyx</span>
          <p>Original daily word game for mobile using React with TypeScript, Netlify Functions, and MS SQL Server.</p>
          <a target="_blank" rel="noreferrer" href="https://acronyx.app">https://acronyx.app</a> 
        </div>
        <div className="project-item">
          <span>Sideline Sports</span>
          <p>Original sports news site for mobile using React with TypeScript, Groq, and Netlify Functions.</p>
          <a target="_blank" rel="noreferrer" href="https://sidelinesports.netlify.app">https://sidelinesports.netlify.app</a> 
        </div>
      </div>
    </div>
  );
}
